import { Link } from 'react-router-dom';
import { Award } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">AsiliGuide</h3>
            <p className="text-sm text-gray-600 mb-4">
              Healthcare onboarding, simplified.
            </p>
            <div className="flex gap-3">
              <Award className="w-5 h-5" style={{ color: '#009688' }} />
              <span className="text-xs text-gray-500">
                Built for regulated healthcare organizations
              </span>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Product</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/preview"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Preview Checklist
                </Link>
              </li>
              <li>
                <Link
                  to="/checkout"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Get Your Snapshot
                </Link>
              </li>
              <li>
                <a
                  href="https://asiliguide.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Main Platform
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  About Us
                </Link>
              </li>
              <li>
                <a
                  href="https://asiliguide.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="https://asiliguide.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="https://asiliguide.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Support</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://asiliguide.com/help"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Help Center
                </a>
              </li>
              <li>
                <a
                  href="mailto:support@getasili.com"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Email Support
                </a>
              </li>
              <li>
                <a
                  href="https://asiliguide.com/docs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Documentation
                </a>
              </li>
              <li>
                <a
                  href="https://asiliguide.com/status"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  System Status
                </a>
              </li>
            </ul>
          </div>

          {/* Affiliates */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Affiliates</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://firstcallhealthstaffing.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  First Call Health Staffing
                </a>
              </li>
              <li>
                <a
                  href="https://asiliguide.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  AsiliGuide Platform
                </a>
              </li>
              <li>
                <a
                  href="https://asiliflow.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  AsiliFlow Platform
                </a>
              </li>
              <li>
                <a
                  href="https://asiliguide.com/compliance/states"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  State Compliance
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-center sm:text-left">
          <p className="text-xs sm:text-sm text-gray-500">
            © {currentYear} AsiliGuide, a product of Asili LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-4 sm:gap-6">
            <a
              href="https://asiliguide.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-500 hover:text-gray-700 transition"
            >
              Privacy
            </a>
            <a
              href="https://asiliguide.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-500 hover:text-gray-700 transition"
            >
              Terms
            </a>
            <a
              href="https://asiliguide.com/security"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-500 hover:text-gray-700 transition"
            >
              Security
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
